export { default, type NewsSectionProps } from './NewsSection';
